export default async function getMain({ context, nextMiddleware }){
    try {
        console.debug('Get main page');
        context.store.dispatch('menuUI/selectTab', 'main');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
